import { CardCvcElement, CardExpiryElement, CardNumberElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { useContext, useMemo, useState } from "react";
import styled from "styled-components";
import PopupContext from "../../../PopupContext";
import info from "../../../assets/icons/info-circle.png";
import closeIcon from "../../../assets/icons/x-close0.svg";
import stripeImg from "../../../assets/images/Stripe.png";
import * as Library from "../../../utils/Library";
import DialogBoxComponent from "../../common/dialogs/DialogBoxComponent";
import FullScreenOverlay from "../overlay/FullScreenOverlay";

// #region SCOPED CSS
const StyledPage = styled.div`
    .payment-details-dialog-card,
    .payment-details-dialog-card * {
        box-sizing: border-box;
    }
    .payment-details-dialog-card {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 4px;
        padding: 16px 24px 16px 24px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        box-shadow: var(--drop-shadow-200-box-shadow, 0px 0px 48.1px 0px rgba(17, 22, 32, 0.51));
    }
    .frame-160 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-158 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-161 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .add-payment-details {
        color: #ffffff;
        text-align: center;
        font-family: var(--heading-4-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--heading-4-font-size, 18px);
        font-weight: var(--heading-4-font-weight, 400);
        position: relative;
        flex: 1;
    }
    .frame-144 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-313309 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .payment-method-form {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 67px;
        position: relative;
    }
    .frame-51 {
        padding: 0px 5px 0px 5px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 12px;
        position: relative;
    }
    .info-circle {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .card-number {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-family: var(--subtitle-3-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-3-font-size, 11px);
        font-weight: var(--subtitle-3-font-weight, 400);
        position: relative;
    }
    .input-selector-inverted {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 38px;
        position: relative;
    }
    .frame-49 {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border-radius: 4px 0px 0px 4px;
        padding: 6px 0px 6px 0px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 5px;
        height: 37px;
        position: relative;
        overflow: hidden;
    }
    .search {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        height: 38px;
        position: relative;
    }
    .frame-48 {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 0px 4px 4px 0px;
        padding: 6px 12px 6px 12px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        height: 37px;
        position: relative;
    }
    .frame-481 {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 0px 4px 4px 0px;
        padding: 3px 12px 3px 12px;
        height: 40px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        border-radius: 4px;
        border-left: 5px solid #f90;
    }

    ._1234-1234-1234-1234 {
        color: var(--text-and-icons-green-500, #00bb00);
        text-align: left;
        font-family: var(--subtitle-2-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-2-font-size, 12px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
        flex: 1;
    }
    .card-logos {
        flex-shrink: 0;
        width: 101px;
        height: 13px;
        position: relative;
    }
    .visa-mastercard-american-express-png-6-1 {
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0%;
        left: 0%;
        bottom: 0%;
        top: 0%;
        object-fit: cover;
    }
    .frame-50 {
        padding: 0px 5px 0px 5px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-end;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313310 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .simple {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-512 {
        padding: 0px 5px 0px 5px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .info-circle2 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .title {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-family: var(--subtitle-3-labels-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-3-labels-font-size, 10px);
        font-weight: var(--subtitle-3-labels-font-weight, 400);
        position: relative;
    }
    .frame-482 {
        background: var(--buttons-all-platforms-gray-500, #10141b);
        border-radius: 4px;
        padding: 6px 12px 6px 12px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        height: 37px;
        position: relative;
    }
    .payment-method-form2 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .info-circle3 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .card-logos2 {
        flex-shrink: 0;
        width: 21px;
        height: 14.25px;
        position: relative;
    }
    .property-1-cvc-1 {
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0%;
        left: 0%;
        bottom: 0%;
        top: 0%;
        object-fit: cover;
    }
    .dropdown-selector {
        width: 100%;
        text-align: left;
    }
    .frame-492 {
        padding: 0px 5px 0px 5px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 8px;
        position: relative;
    }
    .info-circle4 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .search2 {
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        height: 38px;
        position: relative;
    }
    .default-selection {
        color: var(--text-and-icons-green-500, #00bb00);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .chevron-down {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-1000011413 {
        flex-shrink: 0;
        width: 312px;
        height: 35px;
        position: relative;
        cursor: pointer;
        margin-top: 46px;
    }
    .btn-large-solid-inverted-01 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        width: 120px;
        height: 35px;
        position: absolute;
        left: 50%;
        translate: -50%;
        top: 0px;
    }
    .btn-small-filled {
        background-color: rgba(0, 136, 0, 1);

        border-radius: 4px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 35px;
        position: relative;
        margin-top: 5px;
    }
    .btn-small-filled22 {
        background: var(--buttons-all-platforms-gray-500, #10141b);
        border-radius: 4px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 35px;
        position: relative;
        margin-top: 5px;
    }
    .share {
        text-align: left;
        font-family: var(--button-text-large-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--button-text-large-font-size, 12px);
        letter-spacing: var(--button-text-large-letter-spacing, 0.0125em);
        font-weight: var(--button-text-large-font-weight, 400);
        text-transform: uppercase;
        position: relative;
    }
    .disabled {
        pointer-events: none;
        flex-shrink: 0;
        width: 312px;
        height: 35px;
        position: relative;
        color: var(--text-and-icons-gray-300, #4f5b6d);
        margin-top: 46px;
    }
    .frame-162 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: absolute;
        right: -8px;
        top: -2px;
    }
    .x-close {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-1000011414 {
        align-self: stretch;
        flex-shrink: 0;
        height: 13px;
        position: relative;
    }
    .stripe-white-1 {
        width: 31.2px;
        height: 13px;
        position: absolute;
        right: -0.2px;
        top: 0px;
        object-fit: cover;
        aspect-ratio: 31.2/13;
    }
    .processed-by {
        color: #ffffff;
        text-align: left;
        font-family: var(--label-xs-lowercase-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--label-xs-lowercase-font-size, 8px);
        font-weight: var(--label-xs-lowercase-font-weight, 400);
        position: absolute;
        left: 230px;
        top: 0px;
        width: 48px;
        height: 13px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .line-1,
    .line-1 * {
        box-sizing: border-box;
    }
    .line-1 {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-200, #262e3e);
        border-width: 1px 0 0 0;
        flex: 1;
        height: 0px;
        position: relative;
    }
    .cardElement {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 46px;
        border-radius: 5px;
    }
`;
// #endregion

const StripePopup = ({ onSuccess, showDefaultSetupPopup = true }) => {
    // #region STATES
    const [popupState, setPopupState] = useState({
        showStripeLoader: false,
        showDialogBox: false,
        isSuccess: false
    });
    const [cardState, setCardState] = useState({
        numberComplete: false,
        expiryComplete: false,
        cvcComplete: false
    });
    // #endregion

    // #region VARS
    const { setShowStripePopup, showStripePopup } = useContext(PopupContext);

    const stripe = useStripe();
    const elements = useElements();

    const cardStyles = {
        base: {
            "padding": "16px",
            "color": "#fff",
            "fontWeight": "400",
            "fontSize": "14px",
            "fontSmoothing": "antialiased",
            ":-webkit-autofill": {
                "color": "#fff",
                "-webkit-text-fill-color": "#fff",
                "-webkit-box-shadow": "0 0 0 1000px #1e1e1e inset !important",
                "transition": "background-color 5000s ease-in-out 0s"
            },
            "::placeholder": { color: "#8C8C8C" }
        },
        invalid: {
            iconColor: "red",
            color: "red"
        }
    };
    // #endregion

    // #region METHODS
    const updatePopupState = updates => setPopupState(prev => ({ ...prev, ...updates }));

    const handleCardElementChange = type => event => {
        setCardState(prev => ({
            ...prev,
            [`${type}Complete`]: event.complete
        }));
    };

    const isCardValid = useMemo(() => {
        return cardState.numberComplete && cardState.expiryComplete && cardState.cvcComplete;
    }, [cardState]);

    const handleCreatePaymentMethod = async () => {
        if (!stripe || !elements) return;

        try {
            const cardElement = elements.getElement(CardNumberElement);
            const companyID = localStorage.getItem("currentCompanyID") || "";

            const { paymentMethod, error } = await stripe.createPaymentMethod({
                type: "card",
                card: cardElement
            });

            if (error) {
                updatePopupState({ showDialogBox: true });
                return Library.showToastMessage({
                    type: "error",
                    message: `Error: ${error.message || "An error occurred while processing your payment method."}`
                });
            }

            const res = await Library.makeApiRequest({
                endpoint: "Global/createPaymentMethod",
                data: {
                    stripePaymentMethodID: paymentMethod?.id || "",
                    companyID: companyID || ""
                },
                setLoader: loading => updatePopupState({ showStripeLoader: loading })
            });

            if (res?.data?.status === 200) {
                Library.showToastMessage({
                    type: "success",
                    title: "Payment Method Saved",
                    message: "You can now use this method for future transactions."
                });
                if (showDefaultSetupPopup) {
                    onSuccess?.();
                } else {
                    onSuccess?.(true, paymentMethod?.id);
                }
                updatePopupState({ isSuccess: true });
            }

            setShowStripePopup(false);
            setCardState({
                numberComplete: false,
                expiryComplete: false,
                cvcComplete: false
            });
            updatePopupState({ showDialogBox: true });
        } catch (err) {
            Library.showToastMessage({
                type: "error",
                message: "An unexpected error occurred while creating the payment method."
            });
        }
    };
    // #endregion

    // #region RENDER
    return (
        <StyledPage>
            <FullScreenOverlay
                show={popupState.showStripeLoader || (popupState.showDialogBox && showDefaultSetupPopup)}>
                {popupState.showStripeLoader ? (
                    <DialogBoxComponent
                        loading
                        loadingHeading="VALIDATING PAYMENT METHOD..."
                        loaderBgColor="#00BB00"
                        headingColor="#00BB00"
                    />
                ) : showDefaultSetupPopup ? (
                    <DialogBoxComponent
                        headingColor={popupState.isSuccess ? "#00BB00" : "#FF4C4C"}
                        heading={popupState.isSuccess ? "Success..." : "CARD DECLINED"}
                        title={popupState.isSuccess ? "New payment method added!" : "We’re Sorry"}
                        message={
                            popupState.isSuccess
                                ? "Do you want to make it your primary payment method?"
                                : "Your payment method was not validated."
                        }
                        confirmText={popupState.isSuccess ? "YES" : "TRY AGAIN"}
                        cancelText={popupState.isSuccess ? "NO" : "CLOSE"}
                        onClickYes={() => {
                            if (!popupState.isSuccess) {
                                updatePopupState({ showDialogBox: false });
                                setShowStripePopup(true);
                            } else updatePopupState({ showDialogBox: false });
                        }}
                        onClickNo={() => updatePopupState({ showDialogBox: false })}
                        confirmState="secondary"
                    />
                ) : (
                    ""
                )}
            </FullScreenOverlay>

            <FullScreenOverlay show={showStripePopup && !popupState.showStripeLoader}>
                <div className="payment-details-dialog-card">
                    <div className="frame-160">
                        <div className="frame-158">
                            <div className="frame-161">
                                <div className="add-payment-details">Add payment details</div>
                            </div>
                            <div className="frame-162">
                                <img
                                    className="x-close"
                                    src={closeIcon}
                                    alt="Close"
                                    onClick={() => setShowStripePopup(false)}
                                />
                            </div>
                        </div>
                        <div className="line-1" />

                        <div className="frame-313309">
                            <div className="payment-method-form">
                                <div className="frame-51">
                                    <img className="info-circle" src={info} alt="info" />
                                    <div className="card-number">Card number</div>
                                </div>
                                <div className="frame-482 w-100">
                                    <div className="w-100 cardElement">
                                        <CardNumberElement
                                            options={{ style: cardStyles }}
                                            onChange={handleCardElementChange("number")}
                                            className="element"
                                        />
                                    </div>
                                </div>
                                <div className="flex gap-16px mt-4px">
                                    <div className="flex-col">
                                        <div className="frame-51 ">
                                            <img className="info-circle" src={info} alt="info" />
                                            <div className="card-number ">Expiration</div>
                                        </div>
                                        <div className="frame-482 mt-10px" style={{ width: "150px" }}>
                                            <div className="cardElement w-100">
                                                <CardExpiryElement
                                                    options={{ style: cardStyles }}
                                                    onChange={handleCardElementChange("expiry")}
                                                    className="element"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="frame-51">
                                            <img className="info-circle" src={info} alt="info" />
                                            <div className="card-number">CVC</div>
                                        </div>
                                        <div className="frame-482 mt-10px" style={{ width: "150px" }}>
                                            <div className="cardElement w-100">
                                                <CardCvcElement
                                                    options={{ style: cardStyles }}
                                                    onChange={handleCardElementChange("cvc")}
                                                    className="element"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className={`${isCardValid ? "frame-1000011413" : "disabled"}`}
                            onClick={isCardValid ? handleCreatePaymentMethod : undefined}>
                            <div className="btn-large-solid-inverted-01">
                                <div className={`${isCardValid ? "btn-small-filled" : "btn-small-filled22"}`}>
                                    <div className="share">DONE</div>
                                </div>
                            </div>
                        </div>
                        <div className="frame-1000011414">
                            <img className="stripe-white-1" src={stripeImg} alt="Stripe" />
                            <div className="processed-by">processed by</div>
                        </div>
                    </div>
                </div>
            </FullScreenOverlay>
        </StyledPage>
    );
    // #endregion
};

export default StripePopup;
